import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_download",
  "use": "icon_download-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_download\"><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"M21 15v6H3.00002L3 19v-4m4-5 5 5m0 0 5-5m-5 5V3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol